export type { ContentProps } from "./content";
export { Content } from "./content";
